(function () {
  'use strict';

  angular.module('sempraWebapp').service('vacuumKarcherUtils', vacuumKarcherUtilsService);

  /** @ngInject */
  function vacuumKarcherUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getVacuumPoint = function (facilityJson, boxName) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.KARCHER_VACUUM
          && pointJson.name === boxName;
      });
    };

    this.getVacuumPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.KARCHER_VACUUM);
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = {
      STATUS_VACUUM_AVAILABLE: 'STATUS_VACUUM_AVAILABLE',
      STATUS_VACUUM_RUN_TIME: 'STATUS_VACUUM_RUN_TIME',
      TURNOVER_MANUAL_TOKEN: 'TURNOVER_MANUAL_TOKEN',
      TURNOVER: 'TURNOVER'
    };

    this.FeedReferencesProperties = {
      STATUS_VACUUM_AVAILABLE: getFeedPropertiesObject('STATUS_VACUUM_AVAILABLE'),
      STATUS_VACUUM_RUN_TIME: getFeedPropertiesObject('STATUS_VACUUM_RUN_TIME'),
      TURNOVER_MANUAL_TOKEN: getFeedPropertiesObject('TURNOVER_MANUAL_TOKEN'),
      TURNOVER: getFeedPropertiesObject('TURNOVER')
    }

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON: 'OP_BUTTON',
      properties: {
        OP_BUTTON: getActuatorPropertiesObject('OP_BUTTON')
      }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (vacuumPointJson) {
          return modelUtils.getFeedCurrentValue(vacuumPointJson, feedReference);
        },
        getFeed: function (vacuumPointJson) {
          return modelUtils.getFeed(vacuumPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (vacuumPointJson) {
          return modelUtils.getActuatorCurrentValue(vacuumPointJson, actuatorReference);
        },
        getActuator: function (vacuumPointJson) {
          return modelUtils.getActuator(vacuumPointJson, actuatorReference);
        }
      }
    }
  }
})();
